/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  SocialPublishOptions,
  VaultButton,
} from '../../../Shared';
import { selectIsAnySelected, selectTitleForNewAsset } from '../../state/clipList';
import { createAndPublishAsset } from '../../state/actions/createAndPublishAsset';
import { updatePublishingMetadataField } from '../../../../state/publishAssets';
import { selectIsPublishPermitted, selectIsUserVaultSuperAdmin } from '../../../../state/user/userOrgRole';
import TwitterPublishDialog from './TwitterPublishDialog/component';
import YouTubePublishDialog from './YouTubePublishDialog/component';
import VaultPublishOptions from './VaultPublishOptions/component';

const PlainButton = styled(VaultButton).attrs((props) => ({
  variant: 'plainOnPaper',
}))``;

class PublishOptions extends Component {
  handleSocialPublish = async (publishSettings, publishMetadata) => {
    const {
      createAndPublishAssetConnect,
      isVaultSuperAdmin,
    } = this.props;

    return createAndPublishAssetConnect({
      newAssetTitle: publishMetadata.title,
      publishSettings,
      publishMetadata,
      isVaultSuperAdmin,
    });
  };

  handleVaultPublish = async (publishSettings) => {
    const {
      createAndPublishAssetConnect,
      socialPublishing: {
        metadata,
      },
      isVaultSuperAdmin,
    } = this.props;

    return createAndPublishAssetConnect({
      newAssetTitle: metadata.title,
      publishSettings,
      publishMetadata: metadata,
      isVaultSuperAdmin,
    });
  };

  onSocialProfileSelect = (socialType) => {
    const {
      newAssetTitle,
      updatePublishingMetadataFieldConnect,
    } = this.props;

    updatePublishingMetadataFieldConnect('title', newAssetTitle);
  };

  render() {
    const {
      isAnySelected,
      isPublishPermitted,
    } = this.props;

    if (!isPublishPermitted) return null;

    return (
      <>
        <SocialPublishOptions
          disabled={!isAnySelected}
          socialButton={PlainButton}
          onProfileSelect={this.onSocialProfileSelect}
        />
        <VaultPublishOptions
          disabled={!isAnySelected}
          onPublish={this.handleVaultPublish}
          selectedAssets={null}
        />
        <TwitterPublishDialog onPublish={this.handleSocialPublish} />
        <YouTubePublishDialog onPublish={this.handleSocialPublish} />
      </>
    );
  }
}

PublishOptions.defaultProps = {
  socialPublishing: null,
};

PublishOptions.propTypes = {
  isPublishPermitted: PropTypes.bool.isRequired,
  isAnySelected: PropTypes.bool.isRequired,
  newAssetTitle: PropTypes.string.isRequired,
  socialPublishing: PropTypes.object,
  createAndPublishAssetConnect: PropTypes.func.isRequired,
  updatePublishingMetadataFieldConnect: PropTypes.func.isRequired,
  isVaultSuperAdmin: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isPublishPermitted: selectIsPublishPermitted(state),
  isAnySelected: selectIsAnySelected(state),
  newAssetTitle: selectTitleForNewAsset(state),
  socialPublishing: state.publishSelectedAssetsToEndPoints.socialPublishing,
  isVaultSuperAdmin: selectIsUserVaultSuperAdmin(state),
});

const mapDispatchToProps = {
  createAndPublishAssetConnect: createAndPublishAsset,
  updatePublishingMetadataFieldConnect: updatePublishingMetadataField,
};

export default connect(mapStateToProps, mapDispatchToProps)(PublishOptions);
